import { Outlet } from 'react-router-dom'
import classNames from 'classnames'
import { FC, memo } from 'react'

export const AppContentPanel: FC = memo(() => {
  return (
    <div
      id="app-content-panel"
      data-testid="app-content-panel"
      className={classNames('flex flex-col flex-1 min-w-0 overflow-y-auto')}
    >
      <Outlet />
    </div>
  )
})
